import React, { PropTypes } from 'react';
import GenericRadioButtons from './generic-radio-buttons';

const NonAccomTable = props => {
  const {
    dispatchedUpdateProps,
  } = props;

  const oneOrMultiCitiesRadios = [
    {
      label: 'We operate in one city/region.',
      value: 'one-city',
    },
    {
      label: 'We operate in multiple cities/regions.',
      value: 'multi-city',
    },
  ];

  return (
    <div>
      <GenericRadioButtons
        radiosMap={oneOrMultiCitiesRadios}
        name={"oneOrMultiCities"}
        handleOnClick={selected => dispatchedUpdateProps({ oneOrMultiCities: selected })}
      />
    </div>
  );
};

NonAccomTable.propTypes = {
  dispatchedUpdateProps: PropTypes.func,
};

export default NonAccomTable;



// WEBPACK FOOTER //
// ./src/app/components/signup/supplier/nonaccom-table.jsx